module.exports = __webpack_public_path__ + "img/11.74960060.png";